import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseDataService, ModelData } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'yt-odabir-dokumenta',
  templateUrl: './odabir-dokumenta.component.html'
})
export class OdabirDokumentaComponent implements OnInit {

  constructor(
    protected activeModal: NgbActiveModal,
    protected baseDataService: BaseDataService
  ) { }

  Config={};
  modelData:ModelData;
  baseFormGroup = new FormGroup({OdabirID : new FormControl(null, [Validators.required])})
  @Input() Parameters;

  ngOnInit() {

  }

  Save(){
    let odabirID:number = this.baseFormGroup.get("OdabirID").value;
    if (odabirID){
      ///kreiraj broj dokumenta
    }
    else
      alert("Nije odabran dokument!")
    this.activeModal.dismiss();
  }

  Close(){
    this.activeModal.dismiss();
  }

}
